module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAPCAYAAAA/I0V3AAABFklEQVQ4T5XSoUsEURDH8e/se6AIFkHQJGJRwX5oFAyaDKZLBtHiHyAq7HEnglHQZLSIFk02MYlFqyCIWEQMYjk42J2Ru711b8Nxt6/N8Pu8gWGEzhfaIE43MFtFZBbwIG+o3eKDE3blqxmXfxPaNE6vgKncR1nxA7bFvr9J0IGNo/oIjHYBWVt1OUHV6BpkqSdoBeRTqNkEpi/9gSQlVKIygZwVQ9V4GzgqiGwd9LQYSlb9XAy1tqd3YKX+oPy2V96YAf8ADPSEZpvZRdRsHtVLhJEuUBF22HPHGWomQxsjiM8RWchB4x0NyoTylL+9NLVmjrn4ApGVduuVen2Rw+HvNJKflHZD8zi7B5skapSoDH10Tv4DF/tUxCtM+04AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taskPlan/pointStartIcon.png
// module id = lAaD
// module chunks = 2